import { RouteObject } from 'react-router';
import { AdminLayout, MainScreenPlanner } from '../components';
import { AdminRoutes } from './AdminRoutes';
import { PlannerRoutes } from './PlannerRoutes';

export const OnboardedRoutes: RouteObject[] = [
  { path: 'p/:plannerId?', element: <MainScreenPlanner />, children: PlannerRoutes },
  { path: 'school-admin', element: <AdminLayout />, children: AdminRoutes }
];
